<!-- 批量添加费用 -->
<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('receivablePayable.FeeDetails')"
    :visible.sync="isVisible"
    custom-class="drawerClass"
    direction="ltr"
    size="80%"
  >
    <div class="details">
      <OrderTable
        ref="addItemRef"
        :key="key"
        :query-form="queryForm"
        :select-data="selectData"
        :is-open="isVisible"
        :payable-type="payableType"
      />

      <!-- 费用明细 -->
      <FeeTable
        ref="detailsTableRef"
        :key="refreshKey"
        :add-type="1"
        :fee-type-option="feeTypeOption"
        :query-form="queryForm"
        :payable-type="payableType"
        :list="addBatchFeeList"
      />
      <!-- 按钮 -->
      <div class="btn">
        <!--保存-->
        <el-button
          v-permit:remove="permission"
          type="primary"
          size="small"
          @click="submit"
        >{{ $t('basicData.Save') }}</el-button>
        <!--关闭-->
        <el-button size="small" @click="onClose">{{ $t('orderCenterCont.ShutDown') }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import OrderTable from './orderTable.vue';
import FeeTable from './feeTable.vue';
import {
  apiPayableSiteExpenseBatchAddFee,
  apiPayableTransportExpenseBatchAdd
} from '@/api/finance/receivables';
import { isSearchAllEmpty } from '@/views/finance/payableManage/feesPayable/enums.js';
import { getPermission } from './utils.js';

export default {
  components: {
    OrderTable,
    FeeTable
  },

  props: {
    // 费用类型
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 外部搜索条件
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 勾选
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 账单类型
    payableType: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      isVisible: false,
      key: 1,
      addBatchFeeList: [],
      permission: '', // 权限
      refreshKey: new Date().getTime()
    };
  },

  activated() {
    this.permission = getPermission(this.payableType);
  },
  created() {
    this.permission = getPermission(this.payableType);
  },

  methods: {
    open() {
      this.isVisible = true;
      this.key += 1;
      this.addBatchFeeList = [];
      this.refreshKey = new Date().getTime();
    },
    /**
     * 新增费用
     */
    async submit() {
      const isEmptyCondition = isSearchAllEmpty(this.queryForm.params); // 搜索条件是否为空
      const waybillNumberList = await this.$refs.addItemRef.getWaybillNumberList(); // 获取订单信息
      const list = await this.$refs.detailsTableRef.submitEdit(); // 获取费用明细
      console.log(list, '添加费用');
      const str = this.$t('basicData.请添加订单信息'); // 添加订单信息
      const str1 = this.$t('receivablePayable.AddAtLeastOneCharge'); // '最少添加一条费用'
      const str2 = this.$t('receivablePayable.OnlyOneChargeCanBeAdded'); // '只能添加一条费用'
      console.log(isEmptyCondition, waybillNumberList, list, '新增费用明细');
      // 1.校验订单信息是否为空
      {
        const len = waybillNumberList.length;
        if (len === 0) {
          this.$message.warning(str); // 添加订单信息
          return;
        }
      }

      // 2.校验费用
      {
        // 校验未通过直接return；
        if (!list) return;
        // 新增费用
        const len = list.length;
        if (len === 0) {
          this.$message.warning(str1); // '最少添加一条费用'
          return;
        }

        if (len !== 1) {
          this.$message.warning(str2); // '只能添加一条费用'
          return;
        }
      }

      // 请求参数处理
      const obj = this.payableType === 5 ? {
        transportNumbers: waybillNumberList.map(item => item.transportNumber),
        addPriceItem: list
      } : {
        condition: params, // 外部搜索栏的搜索条件
        isEmptyCondition: isEmptyCondition, // 搜索条件是否都为空
        businessType: waybillNumberList[0].businessType,
        orderNums: waybillNumberList.map(item => item.waybillNumber),
        expenseSubList: list,
        payableType: this.payableType
      };
      const { params } = this.queryForm;
      // 勾选的数据--费用列表勾选
      if (this.selectData.length > 0) {
        params.ids = this.selectData.map(item => {
          return item.id;
        });
        obj.isEmptyCondition = true; // 与后台约定如果勾选了，则给后台设置搜索标识条件为空
      }
      console.log(obj, '新增费用');

      const API = this.payableType === 5 ? apiPayableTransportExpenseBatchAdd : apiPayableSiteExpenseBatchAddFee;
      const res = await API(obj);
      if (res.code !== 200) { return; }
      this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully')); // 保存成功
      this.onClose(true);
    },

    onClose(isBool = false) {
      this.isVisible = false;
      this.$emit('close', isBool);
    }
  }

};
</script>

<style scoped lang="scss">
.details {
  padding: 10px 10px 0 10px;
  width: 100%;
  height: calc(100vh - 72px);
  overflow-y: auto;
}

.btn {
  position: sticky;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #eeefee;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
}
</style>
